/* Core */

import { useSelector } from "react-redux";

import { combineReducers, configureStore } from "@reduxjs/toolkit";
import { createWrapper } from "next-redux-wrapper";
import { reducer } from "./rootReducer";
import { middleware } from "./middleware";

const rootReducer = combineReducers(reducer);

export const reduxStore = () =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat(middleware),
  });

/* Types */
export type ReduxStore = ReturnType<typeof reduxStore>;
export type ReduxState = ReturnType<ReduxStore["getState"]>;
export type ReduxDispatch = ReduxStore["dispatch"];

export const wrapper = createWrapper<ReduxStore>(reduxStore);

export function useReduxSelector<T>(value: keyof typeof reducer): T {
  const selectedValue: T = useSelector<ReduxState, T>(
    (state) => state && (state[value] as T),
  );
  return selectedValue;
}
